const enigmes = {
    enigme1: {
        title: " Tête de dragon",
coords:"260,272,300,224", 
       shape: "rect",
        text: "Quand vous appuyez sur l’œil du dragon en pierre, <br>un mécanisme s’enclenche et une cache dans le mur se dévoile.<br>Vous découvrez une broche bleue enrobée dans un tissu en velours.<br> Un petit mot est laissé :<br> 3 flèche haut, D flèche bas, 9 flèche haut, ee flèche haut, a flèche bas, A flèche bas.",  
    },
    enigme2: {
        title: " Tête d’Elaphryon",
 coords:"462,262,523,227",   
     shape: "rect",
        text: "Vous appuyez dessus, <br>vous entendez un petit clic, <br>mais rien de plus.",
    },
    Enigme3: {
        title: "Cachette secrète",
 coords:"744,226,752,215",   
     shape: "rect",
        text: "/cachette",
    },

};
export default enigmes;